export default class BlockPackage {
    constructor(container, options) {
        const defaultOptions = {
            swiperActive: false,
            swiperElement: '.swiper',
            swiperPagination: '.swiper-pagination',
            swiperPaginationNext: '.swiper-button-next',
            swiperPaginationPrevious: '.swiper-button-prev',
            modal: '.package-modal',
            modalTrigger: '.modal-trigger',
            modalClose: '.icon-modal-close',
        };
        
        this.options = Object.assign({}, defaultOptions, options);
        
        this.container = document.querySelector(container);
        this.swiperElem = this.container.querySelector(this.options.swiperElement);
        this.swiperPagination = this.container.querySelector(this.options.swiperPagination);
        this.swiperPaginationNext = this.container.querySelector(this.options.swiperPaginationNext);
        this.swiperPaginationPrevious = this.container.querySelector(this.options.swiperPaginationPrevious);
        this.modals = this.container.querySelectorAll(this.options.modal);
        this.modalOpenButtons = this.container.querySelectorAll(this.options.modalTrigger);
        this.modalCloseButtons = this.container.querySelectorAll(this.options.modalClose);
        
        if(this.options.swiperActive) {
            this.initSlider();
        }

        this.setEvents();
    }

    setEvents() {
        this.modalOpenButtons.forEach(trigger => {
            trigger.addEventListener('click', e => {
                e.stopPropagation()
                this.modals.forEach(modal => {
                    if (modal.dataset.modalId === trigger.dataset.modalOpen) {
                        modal.classList.add('active')
                    }
                })
            })
        })

        this.modalCloseButtons.forEach(icon => {
            icon.addEventListener('click', e => {
                e.stopPropagation();
                this.modals.forEach(modal => {
                    modal.classList.remove('active');
                })
            })
        })  
    }
    
    initSlider() {
        new Swiper(this.swiperElem, {
            direction: 'horizontal',
            loop: false,
            grabCursor: true,
            slidesPerView: 1.15,
            // centeredSlides: true,
            centeredSlides: false,
            initialSlide: 0,
            spaceBetween: 15,
            pagination: {
                el: this.swiperPagination,
                clickable: true
            },
            navigation: {
                nextEl: this.swiperPaginationNext,
                prevEl: this.swiperPaginationPrevious,
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 30
                },
                1200: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 30
                }
            }
        });
    }
}